<template>
  <div id="index">
    <loading :isShow="showOrNot" @nextPage="onNextPage" />
    <page-kv :isShow="showOrNot" @nextPage="onNextPage" />
    <page-one :isShow="showOrNot" @nextPage="onNextPage" />
    <page-two :isShow="showOrNot" :haibao="haibaoData" @nextPage="onNextPage" />
    <music-player />
    <wx-share
      :shareTitle="title"
      :shareDesc="desc"
      :shareImg="thumbImg"
      :shareLink="link"
    />
    <rotate-it />
    <next :subnextload="nextload" />
    <is-pc />
  </div>
</template>

<script>
import Rotate from '../components/rotate/Rotate'
import MusicPlayer from '../components/musicplayer/music-player'
import Loading from '../pages/loading/loading'
import PageKV from '../pages/page-kv/pageKV'
import PageOne from '../pages/page-one/pageOne'
import PageTwo from '../pages/page-two/pageTwo'
import WxShare from '../components/wxShare/wxShare'
import Next from "../pages/next/next";
import Ispc from "../components/ispc/Ispc";

export default {
  name: 'app',
  components: {
    Loading,
    Next,
    'rotate-it': Rotate,
    'music-player': MusicPlayer,
    'page-one': PageOne,
    'page-two': PageTwo,
    'page-kv': PageKV,
    'wx-share': WxShare,
    "is-pc": Ispc,
  },
  data() {
    return {
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false,
      },
      title: '测测你的航天知识等级',
      desc: '测测你的航天知识等级 航天科目——考试（民间版）',
      thumbImg: 'https://jiandoukeji.com/h5/2021/keda/common/thumb2.jpg',
      link: window.location.href,
      nextload:false,
      haibaoData:""
    }
  },
  mounted(){
    
  },
  methods: {
    onNextPage(para) {
      Object.keys(this.showOrNot).map((item) => {
        this.showOrNot[item] = false
      })
      this.showOrNot[para.para] = true
      if(para.para=="isKVShow"){
        this.nextload=true
      }
      if(para.para=="isPTShow"){
        this.haibaoData=para.picpic
      }
    },
  },
}
</script>

<style lang="less" scoped>
// @import './assets/reset.less';
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q, s, samp, small, strike,
strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody,
tfoot, thead, tr, th, td ,textarea,input { margin:0; padding:0;  }
address,cite,dfn,em,var, i {font-style:normal;}
body {font-size: 16px; line-height: 1.5; font-family:'Microsoft Yahei','simsun','arial','tahoma';  color: #222; background: #eee; }
table { border-collapse:collapse; border-spacing:0; }
h1, h2, h3, h4, h5, h6, th { font-size: 100%; font-weight: normal; }
button,input,select,textarea{font-size:100%;}
fieldset,img{border:0;}
a { text-decoration: none; color: #666; background: none }
ul, ol { list-style: none; }
:focus{ outline:none;}
.clearfix{ clear: both; content: ""; display: block; overflow: hidden }
.clear{clear: both;}
.fl{ float: left; }
.fr{float: right;}
html,body{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}

#app {
 width: 100%;
  height: 100%;
  -webkit-user-select: none;
  user-select: none;
  overflow: hidden;
  background-color: #010918;
}
.jianbian{
  animation: jianbianact 1s linear;
}
@keyframes jianbianact {
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}

.xk1 {
  position: absolute;
  left: (2.65rem/2) /* 51/16 */;
  top: (12.4rem/2) /* 266/16 */;
  .bg("../pages/page-kv/img/xk1.png");
  width: (3.75rem/2) /* 60/16 */;
  height: (3.6875rem/2) /* 59/16 */;
  animation: xkshan 2s infinite;
}

.xk2 {
  position: absolute;
  right: (1.1rem/2) /* 33/16 */;
  top: (9rem/2) /* 229/16 */;
  .bg("../pages/page-kv/img/xk1.png");
  width: (3.75rem/2) /* 60/16 */;
  height: (3.6875rem/2) /* 59/16 */;
  animation: xkshan 4s infinite;
}

.xk3 {
  position: absolute;
  left: (17.6875rem/2) /* 283/16 */;
  top: (33.8125rem/2) /* 541/16 */;
  // .bg("./pages/page-kv/img/xk2.png");
  width: (3.0625rem/2) /* 49/16 */;
  height: (3.0625rem/2) /* 49/16 */;
  animation: xkshan2 1.6s infinite;
}

.xk4 {
  position: absolute;
  right: (1rem/2) /* 31/16 */;
  top: -(2rem/2) /* 61/16 */;
  // .bg("./pages/page-kv/img/xk2.png");
  width: (5.4375rem/2) /* 87/16 */;
  height: (5.3125rem/2) /* 85/16 */;
  animation: xkshan 1.2s infinite;
}

.xk5 {
  position: absolute;
  left: (24.9375rem/2) /* 399/16 */;
  top: -(2.3125rem/2) /* 37/16 */;
  // .bg("./pages/page-kv/img/xk4.png");
  width: (4.0625rem/2) /* 65/16 */;
  height: (4rem/2) /* 64/16 */;
  animation: xkshan3 3s infinite;
}

.xk6 {
  position: absolute;
  left: (10.3125rem/2) /* 165/16 */;
  top: (25.8125rem/2) /* 413/16 */;
  // .bg("./pages/page-kv/img/xk5.png");
  width: (4.1875rem/2) /* 67/16 */;
  height: (4.6875rem/2) /* 75/16 */;
  animation: xkshan3 2s infinite;
}

.xk7 {
  position: absolute;
  left: (26.75rem/2) /* 428/16 */;
  top: (19.5rem/2) /* 312/16 */;
  // .bg("./pages/page-kv/img/xk5.png");
  width: (4.1875rem/2) /* 67/16 */;
  height: (4.6875rem/2) /* 75/16 */;
  animation: xkshan2 3s infinite;
}

.xk8 {
  position: absolute;
  left: (9.25rem/2) /* 148/16 */;
  top: (36.5625rem/2) /* 585/16 */;
  // .bg("./pages/page-kv/img/xk5.png");
  width: (4.1875rem/2) /* 67/16 */;
  height: (4.6875rem/2) /* 75/16 */;
  animation: xkshan3 2.5s infinite;
}

.xk9 {
  position: absolute;
  right: (4.9375rem/2) /* 79/16 */;
  top: 3rem;
  // .bg("./pages/page-kv/img/xk5.png");
  width: (3.3125rem/2) /* 53/16 */;
  height: (3.6875rem/2) /* 59/16 */;
  animation: xkshan3 3s infinite;
}

.xk10 {
  position: absolute;
  left: (19.5625rem/2) /* 313/16 */;
  top: (27rem/2) /* 350/16 */;
  // .bg("./pages/page-kv/img/xk5.png");
  width: (3.3125rem/2) /* 53/16 */;
  height: (3.6875rem/2) /* 59/16 */;
  animation: xkshan2 3s infinite;
}

@keyframes xkshan {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}

@keyframes xkshan2 {
  0% {
    opacity: 0.3;
    transform: scale(0.7);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.3;
    transform: scale(0.7);
  }
}

@keyframes xkshan3 {
  0% {
    opacity: 0.66;
    transform: scale(0.7);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.66;
    transform: scale(0.7);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue